import { useCallback } from "react";
import { useFormikContext } from "formik";
import { throttle } from "lodash";
import { useDeepCompareEffect } from "react-use";
import { useSafeSetState } from "./useSafeSetState";
export const useFormikAutoSaveValues = ({ onChangeValues, debounceMs = 1000, disableDebounce = false, }) => {
    const formik = useFormikContext();
    const [state, setState] = useSafeSetState({
        changedAt: "",
        isChanged: false,
    });
    const debouncedOnChange = useCallback(throttle((values) => {
        onChangeValues(values, !state.isChanged);
        setState({ changedAt: new Date().toISOString(), isChanged: true });
    }, debounceMs), [debounceMs]);
    useDeepCompareEffect(() => {
        if (disableDebounce) {
            onChangeValues(formik.values, !state.isChanged);
            setState({ changedAt: new Date().toISOString(), isChanged: true });
        }
        else {
            debouncedOnChange(formik.values);
        }
    }, [debounceMs, disableDebounce, formik.values]);
    return state;
};
export const FormikAutoSaveValues = ({ children = () => null, ...props }) => children(useFormikAutoSaveValues(props));
